<div class="comment-card">
  <div class="thread-row">
    <div class="avatar" [style.background]="getAvatarColor(comment.createdBy)" [title]="comment.createdBy">
      {{ getInitials(comment.createdBy) }}
    </div>

    <div class="thread-body">
      <div class="bubble">
        <div class="bubble-header">
          <span class="author-name">{{ comment.createdBy }}</span>
          <span class="ref-badge"
            >{{ getReferenceTypeKey(comment) | translate }}: {{ getReferenceLabel(comment) }}</span
          >
        </div>

        @if (comment.attachment) {
          <div class="bubble-attachment">
            <app-secured-resource
              [workOrderId]="workOrder.id"
              [commentId]="comment.id"
              [attachmentUrl]="comment.attachment?.url"
              [contentType]="comment.attachment?.type"
            ></app-secured-resource>
          </div>
        }

        <div class="bubble-text">{{ comment.text }}</div>
      </div>

      <div class="meta-row">
        <span class="meta-time">{{ comment.createdTime | dwoDateTime }}</span>

        @if (comment.attachment?.tag) {
          <span class="meta-dot">·</span>
          <app-attachment-tag [text]="comment.attachment.tag"></app-attachment-tag>
        }

        <span class="meta-dot">·</span>
        <button class="meta-btn" (click)="editComment()">
          <i class="material-icons-outlined meta-icon">edit</i>
          {{ 'workOrderComments.edit.editNote' | translate }}
        </button>

        <span class="meta-dot">·</span>
        <button class="meta-btn primary" (click)="openReplyInput()" [disabled]="showReplyInput">
          <i class="material-icons-outlined meta-icon">reply</i>
          {{ 'workOrderComments.replies.replyAction' | translate }}
        </button>

        @if (replyCount > 0) {
          <span class="meta-dot">·</span>
          <button class="meta-btn" (click)="toggleReplies()">
            {{ replyCount }}&nbsp;{{
              (replyCount === 1 ? 'workOrderComments.replies.reply' : 'workOrderComments.replies.replies') | translate
            }}
            &nbsp;·&nbsp;{{
              (repliesExpanded ? 'workOrderComments.replies.hide' : 'workOrderComments.replies.show') | translate
            }}
          </button>
        }
      </div>
    </div>
  </div>

  @if (repliesExpanded || showReplyInput) {
    <div class="replies-section">
      @for (reply of replies; track reply.id) {
        <div class="thread-row">
          <div class="avatar sm" [style.background]="getAvatarColor(reply.createdBy)" [title]="reply.createdBy">
            {{ getInitials(reply.createdBy) }}
          </div>
          <div class="thread-body">
            <div class="bubble sm-bubble">
              <span class="author-name">{{ reply.createdBy }}</span>
              <div class="bubble-text">{{ reply.text }}</div>
            </div>
            <div class="meta-row">
              <span class="meta-time">{{ reply.createdTime | dwoDateTime }}</span>
              <span class="meta-dot">·</span>
              <button class="meta-btn" (click)="editReply(reply)">
                <i class="material-icons-outlined meta-icon">edit</i>
                {{ 'workOrderComments.edit.editNote' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
      @if (showReplyInput) {
        <div class="thread-row compose-row">
          <div class="avatar sm" [style.background]="getAvatarColor(currentUsername)" [title]="currentUsername">
            {{ getInitials(currentUsername) }}
          </div>
          <div class="compose-wrapper">
            <textarea
              class="compose-input"
              [(ngModel)]="replyText"
              placeholder="{{ 'workOrderComments.replies.placeholder' | translate }}"
              rows="2"
              [disabled]="replyLoading"
              (keydown.enter)="onReplyKeydown($event)"
            ></textarea>
            @if (replyLoading) {
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
            <div class="compose-actions">
              <button mat-button (click)="cancelReply()" [disabled]="replyLoading">
                {{ 'workOrderComments.replies.cancel' | translate }}
              </button>
              <button
                mat-flat-button
                color="primary"
                (click)="submitReply()"
                [disabled]="replyLoading || !replyText?.trim()"
              >
                {{ 'workOrderComments.replies.send' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
